import ComissionedRegistration from './ComissionedRegistration';

export default ComissionedRegistration;